import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import Image from '@tcp/core/src/components/common/atoms/Image';

import { getIconPath } from '@tcp/core/src/utils';
import {
  getIsTabletWebSearch,
  getIsMobileWebSearch,
} from '@tcp/core/src/components/common/molecules/SearchBar/WebSearchBar/helpers/webSearchUiHelper';
import style from '../styles/PreviousSearchTile.style';
import withStyles from '../../../hoc/withStyles';
import Anchor from '../../../atoms/Anchor';

// eslint-disable-next-line sonarjs/cognitive-complexity
const PreviousSearchTile = (props) => {
  const {
    className,
    imageUrl,
    searchName,
    gender,
    size,
    color,
    searchUrl,
    closeSearchBar,
    onCloseClick,
    id,
    navigatePrevSearch,
    searchEnhancementRedesign,
  } = props;
  const tiletext = [searchName, gender, size, color];
  let searchtext = '';
  tiletext.forEach((text, index) => {
    if (text && index) {
      searchtext += `${text?.trim()}, `;
    } else if (text && index === 0) {
      searchtext += `${text} ${gender.length || size.length || color.length ? '' : ' '}`;
    }
  });
  const searchIcon = getIconPath('search-magnifying-glass');
  const damImageConfig = ['t_plp_img_m,f_auto', 't_plp_img_t,f_auto', 't_plp_img_d,f_auto'];
  return (
    <Anchor
      className="prev-search"
      to={searchUrl}
      onClick={(e) => {
        e.preventDefault();
        if (getIsTabletWebSearch() || getIsMobileWebSearch()) {
          onCloseClick(e);
        }
        closeSearchBar(e);
        navigatePrevSearch(searchName, searchUrl);
      }}
    >
      <div className={`${className} search-tile-layout`}>
        {!searchEnhancementRedesign
          ? imageUrl?.[0] &&
            imageUrl.map((imgNum, index) =>
              index < 3 ? (
                <React.Fragment key={id?.[index]}>
                  <DamImage
                    className={`stackImg prev-img-${index}`}
                    imgConfigs={damImageConfig}
                    imgData={{
                      alt: searchName,
                      url: imgNum?.replace('.mp4', '.jpg'),
                    }}
                    isProductImage
                    primaryBrand={imageUrl?.[3]}
                  />
                </React.Fragment>
              ) : null
            )
          : imageUrl?.[0] && (
              <React.Fragment key={id?.[0]}>
                <DamImage
                  className={`prev-search-redesign`}
                  imgConfigs={damImageConfig}
                  imgData={{
                    alt: searchName,
                    url: imageUrl?.[0]?.replace('.mp4', '.jpg'),
                  }}
                  isProductImage
                  primaryBrand={imageUrl?.[3]}
                />
              </React.Fragment>
            )}

        {!searchEnhancementRedesign && (
          <Image src={searchIcon} alt="search icon" className="img-search search-image-icon" />
        )}
        <div className="product-text-container multiline-ellipsis">
          <BodyCopy className="product-search-text" fontSize={['fs14']} fontFamily="secondary">
            {`"${searchtext?.substring(0, searchtext.length - 2)}"`}
          </BodyCopy>
        </div>
      </div>
    </Anchor>
  );
};

PreviousSearchTile.propTypes = {
  className: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  searchName: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  gender: PropTypes.string,
  searchUrl: PropTypes.string,
  closeSearchBar: PropTypes.func,
  onCloseClick: PropTypes.func,
  navigatePrevSearch: PropTypes.func,
  id: PropTypes.arrayOf(PropTypes.number),
};
PreviousSearchTile.defaultProps = {
  imageUrl: '',
  searchName: '',
  size: '',
  color: '',
  gender: '',
  searchUrl: '',
  closeSearchBar: () => {},
  onCloseClick: () => {},
  navigatePrevSearch: () => {},
  id: [1, 2, 3],
};

export default withStyles(PreviousSearchTile, style);
export { PreviousSearchTile as PreviousSearchTileVanilla };
